module.exports = __webpack_public_path__ + "img/health.8fe029f2.svg";